import Image from "next/image";
import { useState } from "react";
import Popover from "../popover/popover";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { setFeedbackPopover } from "redux-share/slices/popoversSlice";
import { feedbackLog, sendFluentLog } from "../../../../../logs";
import FeedbackIcon from "../../icon-components/feedbackIcon";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from "react-redux";
import { toast } from "mobin-toast";
import SmsStarIcon from "../../icon-components/smsStarIcon";
import Stars from "./stars";

const negative = [
    { id: 1, text: "کیفیت بد صدا و تصویر" },
    { id: 2, text: "خرابی لینک استریم" },
    { id: 3, text: "حجم مصرفی اینترنت زیاد بود" },
    { id: 4, text: "ظاهر برنامه" },
    { id: 5, text: "عدم تطابق صدا و تصویر" },
    { id: 6, text: "نداشتن زیرنویس" },
    { id: 7, text: "دسترسی برام سخت بود" },
    { id: 8, text: "محتوای ویدیو خوب نبود" }
];

const positive = [
    { id: 1, text: "کیفیت خوب صدا و تصویر" },
    { id: 2, text: "بدون قطع و وصلی" },
    { id: 3, text: "میزان حجم مصرفی اینترنت" },
    { id: 4, text: "ظاهر برنامه" },
    { id: 5, text: "حفظ حریم شخصی" },
    { id: 6, text: "زیرنویس فارسی" },
    { id: 7, text: "دسترسی آسان" },
    { id: 8, text: "محتوای مناسب ویدیو" }
];

const starsLabels = ["خیلی بد", "بد", "متوسط", "خوب", "خیلی خوب"];

const Feedback = () => {
    const [negativeUserSelected, setNegativeUserSelected] = useState<string[]>([]);
    const [positiveUserSelected, setPositiveUserSelected] = useState<string[]>([]);
    const [customText, setCustomText] = useState<string | undefined>("");
    const [userRating, setUserRating] = useState<number>(0);
    const [buttonActive, setButtonActive] = useState<"positive" | "negative">("positive");

    const { feedbackPopover } = useAppSelector(({ popovers: { feedbackPopover } }) => ({ feedbackPopover }), shallowEqual);
    useAppSelector(({ videoData: { isComplexPortrait, isComplexDesktop } }) => ({ isComplexPortrait, isComplexDesktop }), shallowEqual);

    const dispatch = useAppDispatch();

    const handleSubmit = () => {
        let userSelected;
        if (userRating <= 2) userSelected = negativeUserSelected;
        else userSelected = [...positiveUserSelected, ...negativeUserSelected];
        sendFluentLog(feedbackLog(userRating, userSelected, customText));
        toast({ title: "نظر شما با موفقیت ثبت شد.", type: "success" });
        handleCloseModal();
    };

    const handleCloseModal = () => {
        dispatch(setFeedbackPopover(false));
        setCustomText("");
        setPositiveUserSelected([]);
        setNegativeUserSelected([]);
        setUserRating(0);
    };

    const handleNegativeUserSelected = (userNegativeSelected: string) => {
        if (negativeUserSelected.some((negative: string) => negative === userNegativeSelected)) {
            setNegativeUserSelected((prev: string[]) => prev.filter((negative: string) => negative !== userNegativeSelected));
        } else {
            setNegativeUserSelected((prev: string[]) => [...prev, userNegativeSelected]);
        }
    };

    const handlePositiveUserSelected = (userPositiveSelected: string) => {
        if (positiveUserSelected.some((positive: string) => positive === userPositiveSelected)) {
            setPositiveUserSelected((prev: string[]) => prev.filter((positive: string) => positive !== userPositiveSelected));
        } else {
            setPositiveUserSelected((prev: string[]) => [...prev, userPositiveSelected]);
        }
    };

    return (
        <>
            <div
                className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                onClick={() => dispatch(setFeedbackPopover(true))}
            >
                <FeedbackIcon
                    className={`pl-fill-z-gray-500 dark:pl-fill-dark-5 ${
                        conditions(ConditionName.isComplexPortrait) ? "pl-w-4 pl-h-4" : "pl-w-[22px] pl-h-[22px]"
                    }`}
                />
                <p className="pl-whitespace-nowrap">ثبت بازخورد</p>
            </div>
            <Popover
                status={feedbackPopover}
                onClose={handleCloseModal}
                isHeader={true}
                headerTitle={"ثبت بازخورد"}
                isBlurBackground={!conditions(ConditionName.isComplexPortrait)}
                type="modal"
                isFullScreen={conditions(ConditionName.isComplexPortrait)}
                classNames={`pl-w-[480px] ${conditions(ConditionName.isComplexDesktop) && "dark:!pl-bg-dark-3 pl-w-[639px]"} ${
                    conditions(ConditionName.isComplexPortrait)
                        ? "pl-w-screen pl-h-[100dvh] !pl-bg-white dark:!pl-bg-dark-1 !pl-rounded-none"
                        : "!pl-max-h-[90vh]"
                } ${!conditions(ConditionName.isDarkMode) && "!pl-bg-white"}`}
            >
                <>
                    <div className={`pl-mx-4 pl-flex pl-gap-4 ${userRating ? "pl-flex-col-reverse" : "pl-flex-col"}`}>
                        <div>
                            <div className="pl-flex pl-justify-between pl-items-center">
                                <div className="pl-flex pl-items-center pl-gap-1">
                                    <SmsStarIcon className="pl-fill-gray-800 dark:pl-fill-white" />
                                    <p className="pl-text-[16px] pl-font-bold pl-text-gray-800 dark:pl-text-white">امتیاز دادن به ذره‌بین</p>
                                </div>
                                <div className="pl-flex pl-items-center pl-gap-4">
                                    <a href="https://cafebazaar.ir/app/com.zarebin.browser">
                                        <Image src={IMAGES.cafebazaar} width={34} height={34} />
                                    </a>
                                    {/*<a href="https://myket.ir/app/com.zarebin.browser"><Image src={IMAGES.myket} width={34} height={34} /></a>*/}
                                </div>
                            </div>
                            <p className="pl-text-[13px] pl-font-medium pl-text-z-secondary-500 dark:pl-text-secondary pl-mt-2">
                                با امتیاز دادن به ذره‌بین ما را در ارائه خدمات بهتر یاری کنید.
                            </p>
                        </div>
                        <div className="pl-h-[1px] pl-bg-secondary-500" />
                        <div>
                            <p className="pl-text-[16px] pl-font-bold pl-text-gray-800 dark:pl-text-white">
                                {userRating ? "امتیاز به پخش" : "پخش این برنامه چطور بود؟"}
                            </p>
                            <div
                                className={`pl-flex pl-flex-row-reverse pl-justify-center pl-items-center pl-gap-6 pl-mt-6 ${
                                    conditions(ConditionName.isComplexDesktop) &&
                                    !userRating &&
                                    "pl-border pl-border-secondary-300 dark:pl-border-secondary-400 pl-p-4 pl-rounded-[8px]"
                                }`}
                            >
                                <Stars
                                    userRating={userRating}
                                    setUserRating={setUserRating}
                                    setButtonActive={setButtonActive}
                                    starsLabels={starsLabels}
                                />
                            </div>
                            <p className="pl-text-[14px] pl-font-medium pl-text-center pl-text-z-gray-500 dark:pl-text-white pl-mt-2">
                                {starsLabels[userRating - 1]}
                            </p>
                        </div>
                    </div>
                    {!!userRating && (
                        <div className="pl-mx-4">
                            <div className="pl-h-[1px] pl-bg-secondary-500 pl-my-4" />
                            <div className="pl-text-center">
                                {userRating === 1 ? (
                                    <p className="pl-w-max pl-text-[15px] pl-font-medium pl-text-gray-800 dark:pl-text-white pl-mx-auto pl-border-b-[2px] pl-border-b-gray-800 dark:pl-border-b-white">
                                        چه مشکلی پیش آمد؟
                                    </p>
                                ) : (
                                    <div className="pl-w-full pl-flex pl-items-center pl-text-[15px]">
                                        <button
                                            className={`pl-w-full pl-mx-auto ${
                                                buttonActive === "positive" && "pl-border-b-[2px] pl-border-b-gray-800 dark:pl-border-b-white"
                                            }`}
                                            onClick={() => setButtonActive("positive")}
                                        >
                                            نقاط مثبت
                                        </button>
                                        <button
                                            className={`pl-w-full pl-mx-auto ${
                                                buttonActive === "negative" && "pl-border-b-[2px] pl-border-b-gray-800 dark:pl-border-b-white"
                                            }`}
                                            onClick={() => setButtonActive("negative")}
                                        >
                                            نقاط منفی
                                        </button>
                                    </div>
                                )}
                                <div className="pl-h-[1px] pl-bg-secondary-500" />
                            </div>
                            <div className="pl-flex pl-flex-wrap pl-items-center pl-gap-[10px] pl-mt-4">
                                {buttonActive === "negative" ? (
                                    <>
                                        {negative.map((item: { id: number; text: string }) => (
                                            <button
                                                className={`pl-flex-grow pl-border dark:pl-border-none pl-border-secondary-400 pl-rounded-[16px] pl-text-secondary-600 dark:pl-text-z-secondary-50 dark:pl-bg-dark-1 pl-px-3 pl-py-[6px] pl-text-[12px] pl-font-normal ${
                                                    negativeUserSelected.some((negative: string) => negative === item.text) &&
                                                    "text-z-gray-700 dark:text-white !pl-border-main !pl-bg-main/[0.08] dark:!pl-border-main dark:!pl-bg-main pl-font-medium"
                                                }`}
                                                onClick={() => handleNegativeUserSelected(item.text)}
                                            >
                                                {item.text}
                                            </button>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {positive.map((item: { id: number; text: string }) => (
                                            <button
                                                className={`pl-flex-grow pl-border dark:pl-border-none pl-border-secondary-400 pl-rounded-[16px] pl-text-secondary-600 dark:pl-text-z-secondary-50 dark:pl-bg-dark-1 pl-px-3 pl-py-[6px] pl-text-[12px] pl-font-normal ${
                                                    positiveUserSelected.some((positive: string) => positive === item.text) &&
                                                    "text-z-gray-700 dark:text-white !pl-border-main !pl-bg-main/[0.08] dark:!pl-border-main dark:!pl-bg-main pl-font-medium"
                                                }`}
                                                onClick={() => handlePositiveUserSelected(item.text)}
                                            >
                                                {item.text}
                                            </button>
                                        ))}
                                    </>
                                )}
                            </div>
                            <div className="pl-h-[1px] pl-bg-secondary-500 pl-my-4" />
                            {!conditions(ConditionName.isIOS) && (
                                <div
                                    className={`pl-text-z-secondary-600 dark:pl-text-secondary-300 pl-bg-main/[0.08] dark:pl-bg-main-highLight/[0.5] pl-px-3 pl-rounded-[10px] pl-text-[13px] pl-font-normal`}
                                >
                                    <input
                                        className="pl-w-full pl-bg-transparent pl-outline-none pl-placeholder-z-secondary-600 dark:pl-placeholder-secondary-300 pl-px-3 pl-py-5 pl-placeholder-text-[80px]"
                                        placeholder={"لطفا پیشنهاد و نظر خود را ثبت کنید."}
                                        onChange={(e) => setCustomText(e.target.value)}
                                    />
                                </div>
                            )}
                            <div className={`pl-flex pl-gap-3 pl-w-full pl-justify-start pl-my-4`}>
                                <button
                                    type="button"
                                    className={`pl-py-2 pl-px-6 pl-rounded-[8px] pl-w-full pl-text-[15px] pl-font-medium pl-cursor-pointer pl-transition-colors pl-duration-300 !pl-bg-main pl-text-white hover:pl-bg-main-700 disabled:!pl-opacity-50`}
                                    onClick={handleSubmit}
                                >
                                    ثبت بازخورد
                                </button>
                                <button
                                    type="button"
                                    data-modal-toggle="small-modal"
                                    className={`pl-w-[125px] pl-border-[1.5px] pl-border-secondary-400 pl-text-z-gray-700 dark:pl-text-secondary-50 pl-py-2 pl-px-6 pl-rounded-[8px] pl-text-[15px] pl-font-medium}`}
                                    onClick={handleCloseModal}
                                >
                                    بعدا
                                </button>
                            </div>
                        </div>
                    )}
                </>
            </Popover>
        </>
    );
};

export default Feedback;
